
import api from '@/api';

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  async countForMaker(store, makerId) {
    try {
      const { data: counts } = await api.get(`/inbox/count/maker/${makerId}`);

      return counts;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async fetchRecurrentInterventionsForMaker(store, makerId) {
    try {
      const { data: recurrentInterventions } = await api.get(`/inbox/recurrent-interventions/maker/${makerId}`);

      return recurrentInterventions;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async markAccepted(store, inboxInterventionId) {
    try {
      const { data: inboxIntervention } = await api.post(`/inbox/${inboxInterventionId}/accepted`);

      return inboxIntervention;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async markRefused(store, inboxInterventionId) {
    try {
      const { data: inboxIntervention } = await api.post(`/inbox/${inboxInterventionId}/refused`);

      return inboxIntervention;
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
